import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  inject,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { OrderSelectionService } from 'src/app/selection/order-selection.service';

@Component({
  selector: 'app-select-all-header',
  templateUrl: './select-all-header.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectAllHeaderComponent implements IHeaderAngularComp, OnDestroy {
  private orderSelectionService = inject(OrderSelectionService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  public params!: IHeaderParams;
  public isAllSelected = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private selectAllSub?: Subscription;

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.selectAllSub?.unsubscribe();
    this.selectAllSub = this.orderSelectionService.selectAllChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => this.updateCheckboxes(data));
  }
  public toggleSelect(): void {
    if (!this.params || !this.params.api) {
      return;
    }

    this.isAllSelected = !this.isAllSelected;
    this.orderSelectionService
      .changeOrdersSelection(this.isAllSelected, this.selectedIds())
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.params.api.forEachNode((node) => {
            if (!node || !node.data) {
              return;
            }
            node.data.selected = false;
            node.setSelected(false);
          });
          if (this.isAllSelected) {
            this.params.api.forEachNodeAfterFilter((node) => {
              if (!node || !node.data || !node.data.id) {
                return;
              }
              node.data.selected = true;
              node.setSelected(true);
            });
          }
        },
        error: () => {
          this.isAllSelected = !this.isAllSelected;
          this.changeDetectorRef.markForCheck();
        },
      });
  }

  private updateCheckboxes(isAllSelected: boolean): void {
    this.isAllSelected = isAllSelected;
    if (this.orderSelectionService.getTotalCount() === 0) {
      this.isAllSelected = false;
    }
    this.changeDetectorRef.markForCheck();
  }

  private selectedIds(): string[] {
    const items: string[] = [];
    if (this.isAllSelected && this.params?.api) {
      this.params.api.forEachNodeAfterFilter((node) => {
        if (node?.data?.id) {
          items.push(node.data.id);
        }
      });
    }
    return items;
  }

  refresh(): boolean {
    return false;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
